/**
 * Guía: Publicidad.
 *
 * Contenido derivado del capítulo **33** del manual: §0 (esto factura: el
 * modelo de cobro y por qué cada impresión y cada clic son dinero) y el
 * flujo F32, que es lo que se le responde a un comercio.
 *
 * El primer paso es el que ordena todo el resto: con cobro por impresiones o
 * por clics, cada fila registrada tiene coste. Sin esa lectura, la pantalla
 * parece un gestor de banners.
 */

import type { TourFlow } from '../types';

const PUBLICIDAD_PATH = '/advertising';

export const c33Publicidad: TourFlow = {
  id: 'admin.advertising',
  chapter: '33',
  title: 'Publicidad',
  summary:
    'Campañas que facturan: los tres modelos de cobro y por qué un anuncio no cambia nada del pedido.',
  href: PUBLICIDAD_PATH,
  requiresCountry: true,
  estimatedMin: 3,
  steps: [
    {
      id: 'intro',
      title: 'Esto factura',
      body:
        'Una campaña de publicidad no guarda sólo fechas e imágenes: guarda cómo se cobra. ' +
        'Por mil impresiones, por clic, o una tarifa fija. Con los dos primeros, **cada ' +
        'impresión y cada clic registrados son dinero**.',
      route: PUBLICIDAD_PATH,
    },
    {
      id: 'who-pays',
      title: 'Con patrocinador o propia',
      body:
        'Una campaña puede tener una empresa detrás que la paga, o ser de la propia ' +
        'plataforma. Es lo primero que hay que mirar al revisar una: cambia quién responde ' +
        'del presupuesto.',
      target: 'admin.advertising.table',
      placement: 'top',
      optionalTarget: true,
    },
    {
      id: 'not-a-promotion',
      title: 'Un anuncio no cambia el pedido',
      body:
        'Ni el precio, ni las promociones, ni los puntos. Es visibilidad y nada más. Por ' +
        'eso «entré por el anuncio y no me hicieron descuento» es correcto: si además hay ' +
        'descuento, es una promoción aparte que montó el comercio.',
    },
    {
      id: 'budget',
      title: 'El presupuesto es el tope acordado',
      body:
        'Con cobro por impresiones o por clics, el gasto sube solo con el uso. Revisar el ' +
        'consumo contra el presupuesto es lo que evita pasarse de lo pactado con el ' +
        'patrocinador.',
    },
    {
      id: 'filters',
      title: 'Buscar y acotar por estado',
      body:
        'El listado está acotado al país seleccionado. Una campaña que no aparece suele ' +
        'estar en otro país o en otro estado del que tienes filtrado.',
      target: 'admin.advertising.filters',
      placement: 'bottom',
      optionalTarget: true,
    },
  ],
};
